<template>
    <div class="message-item--time"
        :id="id">
        <div class="content-wrap">
            <p class="time">{{content}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MessageTime',
        props: {
            baseProps: {
                type: Object,
                required: true
            },
            content: {
                type: String,
                required: true,
                validator (value) {
                    return value.trim() !== ''
                }
            }
        },
        computed: {
            id () {
                return this.baseProps['id']
            }
        }
    }
</script>

<style lang="scss" scoped>
    .content-wrap {
        display: flex;
        align-content: center;
        justify-content: center;
    }

    .time {
        color: #999999;
        font-size: 12px;
        line-height: 1;
        text-align: center;
    }
</style>
